var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStateLandlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8345_288444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.56934 8.67121V6.01883C5.56934 3.30711 7.78857 1.08789 10.5003 1.08789C13.2121 1.08789 15.4313 3.30711 15.4313 6.01883V8.67121",
    stroke: "#FF6933",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3629 8.67139H4.63771C2.95981 8.67139 1.59961 10.0316 1.59961 11.7095V19.8743C1.59961 21.5522 2.95981 22.9124 4.63771 22.9124H16.3629C18.0408 22.9124 19.401 21.5522 19.401 19.8743V11.7095C19.401 10.0316 18.0408 8.67139 16.3629 8.67139Z",
    fill: "#FF6933",
    stroke: "#FF6933",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.7993V18.4158",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3011 14.904C12.3011 15.8839 11.493 16.6761 10.5002 16.6761C9.50738 16.6761 8.69922 15.8809 8.69922 14.904C8.69922 13.9271 9.50738 13.1318 10.5002 13.1318C11.493 13.1318 12.3011 13.9271 12.3011 14.904Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8345_288444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9771,
    height: 24,
    fill: "white",
    transform: "translate(0.511719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateLandlockIcon);
export default __webpack_public_path__ + "static/media/stateLandlockIcon.9241b82274c35d0054b73eb22246e387.svg";
export { ForwardRef as ReactComponent };